module.exports = __webpack_public_path__ + "static/Veneers 2 smile before-c650dad7e0ee93a8574ab059b548220e.jpg";